import { ReactNode } from "react";

import { Edit } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";
import { useToggle } from "hooks/useToggle";
import useTypedContext from "hooks/useTypedContext";

import { ModuleFormContext } from "../context";
import { ModuleCreationWizardStep } from "../types";
import { useNewModuleAnalyticsSegmentEvent } from "../useNewModuleAnalyticsSegmentEvent";

type NewModuleSummaryPanelProps = {
  name: string;
  step: ModuleCreationWizardStep;
  children: ReactNode;
  goToStepDisabled?: boolean;
  count?: number;
  fullbleed?: boolean;
};

const NewModuleSummaryPanel = ({
  name,
  step,
  children,
  count,
  goToStepDisabled,
  fullbleed,
}: NewModuleSummaryPanelProps) => {
  const { setCurrentStep } = useTypedContext(ModuleFormContext);
  const [isCollapsed, toggle] = useToggle(false);
  const trackSegmentEvent = useNewModuleAnalyticsSegmentEvent();

  const goToStep = () => {
    trackSegmentEvent("Summary Edit Click", {
      step: name,
    });
    setCurrentStep(step);
  };

  return (
    <CardCollapsible
      ariaLevel={3}
      ariaLabel={name}
      title={name}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={count !== undefined ? <Counter count={count} /> : undefined}
      headerSuffix={
        <ButtonIcon disabled={goToStepDisabled} icon={Edit} onPress={goToStep} variant="ghost">
          Edit step
        </ButtonIcon>
      }
      analyticsPage={AnalyticsPageModule.ModuleNew}
      analyticsProps={{ step: name }}
      analyticsTitle="Summary section toggle"
      fullbleed={fullbleed}
    >
      {children}
    </CardCollapsible>
  );
};

export default NewModuleSummaryPanel;
